import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEasyFix = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_108700_168363)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M29.2416 11.4979C29.2643 11.5183 29.2841 11.5445 29.2983 11.5707C30.9406 14.4311 30.564 18.1771 28.1741 20.6384C26.2741 22.5929 23.5841 23.2367 21.1631 22.5726L12.8694 31.1043C12.7873 31.1917 12.6457 31.1859 12.5579 31.0956L7.75272 26.1525C7.66494 26.0622 7.65928 25.9194 7.74423 25.832L16.0408 17.2974C15.6656 15.8455 15.7236 14.2984 16.214 12.8738H18.0385V10.287H17.7399C17.7998 10.2208 17.8611 10.1554 17.9238 10.091C20.3165 7.63252 23.9579 7.24511 26.7385 8.93457C26.9112 9.03943 26.9679 9.26663 26.8659 9.44432C26.8489 9.47053 26.832 9.49384 26.8093 9.51714L21.9276 14.5389L23.8503 16.5167L28.7291 11.4979C28.8707 11.3522 29.1001 11.3522 29.2416 11.4979ZM20.6563 20.1316C22.6186 21.1715 25.0877 20.8452 26.7329 19.1529C27.8428 18.0139 28.3554 16.4701 28.2506 14.9613L24.4902 18.8295C24.3201 19.0044 24.0894 19.1026 23.8489 19.1026C23.6084 19.1026 23.3777 19.0044 23.2075 18.8295L19.6822 15.203C19.5122 15.028 19.4168 14.7907 19.4168 14.5433C19.4168 14.2959 19.5122 14.0586 19.6822 13.8835L23.4454 10.0152C22.6967 9.95783 21.9449 10.0673 21.2412 10.3363C20.5375 10.6053 19.8985 11.0273 19.3679 11.5736C17.7227 13.266 17.4056 15.806 18.4165 17.8246L16.9214 19.3626C16.9186 19.3626 16.9186 19.3597 16.9186 19.3597L10.4031 26.0622L12.6457 28.3691L20.4043 20.385L20.4071 20.3879L20.6563 20.1316Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.8828 10.5452C11.4606 10.5452 11.9297 10.0761 11.9297 9.49837V6.56683C11.9297 5.98906 11.4606 5.51996 10.8828 5.51996C10.305 5.51996 9.83594 5.98906 9.83594 6.56683V9.49837C9.83594 10.0761 10.2969 10.5452 10.8828 10.5452Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.8828 17.4376C11.4606 17.4376 11.9297 16.9684 11.9297 16.3907V13.4762C11.9297 12.8984 11.4606 12.4293 10.8828 12.4293C10.305 12.4293 9.83594 12.8984 9.83594 13.4762V16.3907C9.83594 16.9684 10.2969 17.4376 10.8828 17.4376Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.89056 10.4355H5.97607C5.3983 10.4355 4.9292 10.9046 4.9292 11.4824C4.9292 12.0601 5.3983 12.5292 5.97607 12.5292H8.89056C9.46833 12.5292 9.93743 12.0601 9.93743 11.4824C9.93743 10.9046 9.46891 10.4355 8.89056 10.4355Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12.8686 12.5307H15.8002C16.378 12.5307 16.8471 12.0616 16.8471 11.4838C16.8471 10.9061 16.378 10.437 15.8002 10.437H12.8686C12.2909 10.437 11.8218 10.9061 11.8218 11.4838C11.8218 12.0616 12.2909 12.5307 12.8686 12.5307Z",
					fill: "currentColor"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_108700_168363",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 26,
				height: 26,
				fill: "white",
				transform: "translate(5 5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgEasyFix);
export { ForwardRef as ReactComponent };
